import Layout from "../../components/layouts/layout.comp";
import ProductEditor from "../../components/product/productEditor.comp";
import { EditingMode } from "../../components/reuseables/form.comp";
import { useTranslation } from "../../core/translation.core";

export default function ProductCreatePage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.product.add)}>
      <h1>{t(msg.product.add)}</h1>
      <ProductEditor editingMode={EditingMode.create} />
    </Layout>
  );
}
